import { render, staticRenderFns } from "./IPRestrictionList.vue?vue&type=template&id=01668ceb&scoped=true&"
import script from "./IPRestrictionList.vue?vue&type=script&lang=ts&"
export * from "./IPRestrictionList.vue?vue&type=script&lang=ts&"
import style0 from "./IPRestrictionList.vue?vue&type=style&index=0&id=01668ceb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01668ceb",
  null
  
)

export default component.exports